import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import React, { FC } from 'react';
import type { ColorValue } from '~/global.style';

export interface IndustryTableProps {
  title: string;
  caption?: string;
  color?: ColorValue;
  icon?: React.ReactNode;
  counts?: React.ReactNode;
  children: React.ReactNode;
}

export const IndustryTable: FC<IndustryTableProps> = ({
  title,
  caption,
  color,
  icon,
  counts,
  children,
}) => {
  const accentColor = color || '#1976d2';

  return (
    <Card
      variant="outlined"
      elevation={0}
      sx={{
        borderLeft: `4px solid ${accentColor}`,
        mb: 3,
      }}>
      <Box
        sx={{
          px: 2,
          pt: 2,
          pb: 1,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
        }}>
        <Stack direction="row" alignItems="center" gap={1}>
          {icon && (
            <Avatar variant="rounded" sx={{ backgroundColor: color }}>
              {icon}
            </Avatar>
          )}
          <Box>
            {caption && (
              <Typography
                variant="caption"
                sx={{
                  color: accentColor,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  display: 'block',
                  textIndent: '3px',
                }}>
                {caption}
              </Typography>
            )}
            <Typography variant="h5" fontWeight="bold">
              {title}
            </Typography>
          </Box>
        </Stack>

        {counts && (
          <Box sx={{ flexShrink: 0, textAlign: 'right' }}>{counts}</Box>
        )}
      </Box>

      <Divider
        sx={{ borderBottomWidth: '2px', mx: 2, mt: 1, borderColor: color }}
      />

      <CardContent sx={{ pt: 0, px: 0, '&:last-child': { pb: 0 } }}>
        {children}
      </CardContent>
    </Card>
  );
};
